import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { RestCallService } from 'src/app/core/services/rest-call/rest-call.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IEmployee } from '../Interfaces/IEmployee';
import { IRoles } from '../Interfaces/IRoles';
import { IEmployeefromsap } from '../Interfaces/IEmployeefromsap';
import { ISites } from '../Interfaces/ISites';
import { GeneralServices } from '../services/general-services';
import { IEmployeesInActiveDirectory } from '../Interfaces/IEmployeesInActiveDirectory';
import { IWorkdayEmployee } from '../Interfaces/IWorkdayEmployee';
import { ActiveDirectoryService } from './activedirectory-service';

@Injectable({
	providedIn: 'root',
})
export class EmployeeService extends RestCallService {
	dataToSend: IEmployee = {
		pk_employee: 0,
		name: '',
		employee_name: '',
		workday_id: '',
		email: '',
		fk_role: 0,
		fk_sites: [],
		username: '',
		fk_employee_creator: 0,
		employee_creator_name: '',
		last_updated: new Date(),
		str_last_updated: '',
		fk_employee_updater: 0,
		available: true,
		creation_date: undefined,
		str_creation_date: '',
		check: true,
		username_updater: '',
		site: '',
		fkSite: 0
	};

	constructor(
		public httpClient: HttpClient,
		private generalServices: GeneralServices,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
		private activeDirectoryService: ActiveDirectoryService,
	) {
		super(
			httpClient,
			'API_Benefits',
			toastr,
			notificationService,
			translate,
		);
	}

	public GetByUsername( username: string ){
		this.generalServices.ValidateCognito();

		let dataToSend = {
			fkSite: parseInt(localStorage.getItem('fksite')),
			employeeUsername: username
		};

		return this.post<IEmployee[]>(
			'/api/Employees/GetByUsername',
			dataToSend
		);
	}

	public Get() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fkSite =  parseInt( localStorage.getItem('fksite') );

		return this.post<IEmployee[]>( 
			'/api/Employees/Get', 
			this.dataToSend
		);
	}

	public UpdateEmployee(data: any, employee: IEmployeesInActiveDirectory) {
		this.generalServices.ValidateCognito();
		this.dataToSend.pk_employee = data.pkEmployee;
		this.dataToSend.workday_id = employee.workdayId;
		this.dataToSend.username = employee.userName;
		this.dataToSend.employee_name = employee.name;
		this.dataToSend.email = employee.email == null ? '' : employee.email;
		this.dataToSend.fk_role = data.cbRole == null ? 0 : data.cbRole;
		this.dataToSend.fkSite = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.put<IEmployee>(
			'/api/Employees/Update',
			this.dataToSend,
		);
	}

	public CreateEmployee(employee: IEmployeesInActiveDirectory, data: any) {
		
		this.generalServices.ValidateCognito();
		this.dataToSend.workday_id = employee.workdayId;
		this.dataToSend.username = employee.userName;
		this.dataToSend.employee_name = employee.name;
		this.dataToSend.email = employee.email;
		this.dataToSend.fk_role = data.cbRole;
		this.dataToSend.fkSite = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<IEmployee>(
			'/api/Employees/Create',
			this.dataToSend,
		);
	}

	public SetSitesAndRoles(data: any, data2: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.pk_employee = data.pk_employee;
		this.dataToSend.workday_id = data.txtWorkdayid;
		this.dataToSend.username = data.username;
		this.dataToSend.employee_name = data.txtEmployeeName;
		this.dataToSend.fk_sites = data2;
		this.dataToSend.email = data.email == null ? '' : data.email;
		this.dataToSend.fk_role = data.fk_role == null ? 0 : data.fk_role;
		this.dataToSend.fkSite= parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<IEmployee>(
			'/api/Employees/setSitesAndRoles',
			this.dataToSend,
		);
	}

	public VerifyEmailInEmployee(data: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.fkSite = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<IEmployee>(
			'/api/Employees/VerifyEmailInEmployee',
			this.dataToSend,
		);
	}

	public ChangeStatus(data: IEmployee) {
		this.generalServices.ValidateCognito();
		this.dataToSend.pk_employee = data.pk_employee;
		this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
		return this.put('/api/Employees/ChangeStatus', this.dataToSend);
	}

	public IsAdmin() {
		this.generalServices.ValidateCognito();
		this.dataToSend.username = this.activeDirectoryService.employee.workdayId;
		this.dataToSend.workday_id = this.activeDirectoryService.employee.workdayId;
		return this.post<IRoles>('/api/Employees/IsAdmin', this.dataToSend);
	}

	public GetUserInfo(workdayid: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.username = workdayid;
		this.dataToSend.workday_id = workdayid;
		return this.post<IWorkdayEmployee>(
			'/api/Employees/GetUserInfo',
			this.dataToSend,
		);
	}

	public GetSitesByUser(data: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
		this.dataToSend.username = data.username;
		return this.post<ISites[]>(
			'/api/Employees/GetSitesByUser',
			this.dataToSend,
		);
	}

	public GetCurrentUser() {
		this.generalServices.ValidateCognito();
		const dataToSend = { fkSite: 0 };
		if(localStorage.getItem('fksite')){
			dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
		}
		return this.post<IEmployee[]>(
			'/api/Employees/GetCurrentUser',
			dataToSend,
		);
	}
}
